import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import Form from '../form/Form';
import DataTable from '../datatable/DataTable';
import FieldGroup from '../field_group/FieldGroup';
import { getErrorValue } from '../../utils/utility';

import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import {
  createAttachment,
  deleteAttachment,
  listAttachment,
} from '../../redux/project_inspection/submission_attachment_actions';

const DropFileStatus = {
  IN_PROGRESS: 'DF_IN_PROGRESS',
  COMPLETED: 'DF_COMPLETED',
  ERROR: 'DF_ERROR',
};

const maxSize = 52428800; //50MB
class DropFileList extends React.Component {

  static createDropFileWithFile(id, file) {
 
    return {
      id,
      externalId: null,
      name: file.name,
      size: file.size,
      type: file.type,
      file: file,
      status: DropFileStatus.IN_PROGRESS,
    };
  }

  constructor(props) {
    super(props);

    const { t } = props;
    this.columns = [
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        id: 'file-size',
        Header: () => <b>{`${t('size (kB)')}`}</b>,
        accessor: item => Math.floor(item.size / 1024),
        ...getColumnStyle(COLUMN_STYLE.decimal),
        width: 130,
      },
    ];

    this.lastFileID = 1000;
    this.state = {
      files: props.files,
    };
  }

  getFieldState() {
    return {
      value: '',
      isValid: true,
      isDirty: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ files: nextProps.files });
  }

  addFileHandler(file) {
    const { clearFileError } = this.props;
    if(!file) return false;  
    clearFileError && clearFileError(); 
    const newId = this.lastFileID++;
    const droppedFile = DropFileList.createDropFileWithFile(newId, file);

    this.setState(
      { files: [droppedFile, ...this.state.files] },
      () => this.props.onAddFile(file)
          .then((externalId) => {
            const updatedFiles = this.state.files.map(file => file.id === newId
              ? { ...file, externalId, status: DropFileStatus.COMPLETED }
              : file,
            );
            this.setState({ files: updatedFiles });
          })
    );
  }

  deleteFileHandler(deleteIndex) {
    const file = this.state.files[deleteIndex];
    this.props.onDeleteFile(file.externalId)
      .then(() => this.setState({ files: this.state.files.filter(({ externalId }) =>  externalId !== file.externalId)}));
  }

  rejectFunction = ({name,size}) =>{
    const { fileError, t } = this.props;
    const allowedExtensions = /(\.doc|\.docx|\.pdf|\.jpg|\.png)$/i; 
    if(!allowedExtensions.exec(name)){
      fileError(t("wrong type file"));
    }else if(size > maxSize){
      fileError(t("file size exceed"));
    }
  }
  render() {
    const { acceptFileExt, t } = this.props;
    const { files, isUploading } = this.state;

    return (
      <Row>
        <Col xs={12} md={9}>
          <DataTable
            columns={this.columns}
            data={files}
            onActionDelete={item => this.deleteFileHandler(item.index)}
            filteredCount={files.length}
          />
        </Col>
        <Col xs={12} md={3}>
          <Dropzone
            multiple={false}
            accept={acceptFileExt}
            maxSize={maxSize}
            onDropRejected={(ref)=> this.rejectFunction(ref[0])}
            onDrop={acceptedFiles => acceptedFiles && this.addFileHandler(acceptedFiles[0])}
          >
            <div style={{paddingTop:"32%", textAlign:"center"}}>
              <p>{isUploading ? `${t('uploading')}...` : t('drop zone suggestion')}</p>
              <p style={{fontSize:"12px", color:"red", fontWeight:"bold"}}>({t('file limit')})</p>
            </div>
          </Dropzone>
        </Col>
      </Row>
    );
  }
}

DropFileList.defaultProps = {
  files: [],
  onAddFile: (file) => {}, // @return promise
  onDeleteFile: (id) => {}, // @return promise
};

export class ProjectSubmissionDetail extends React.Component {
  static createDropFileWithAttachment(attachment) {
    return {
      id: attachment.id,
      externalId: attachment.id,
      name: attachment.name,
      size: attachment.size,
      type: attachment.type,
      file: null,
      status: DropFileStatus.IN_PROGRESS,
    };
  }

  constructor(props) {
    super(props);
    this.formRef = null;
    this.state = {
      fileErrorMessage : undefined,
    }
  }
  fileError = (errorMessage)=>{
    this.setState({ fileErrorMessage : errorMessage });
  };
  clearFileError = () =>{
    this.setState({ fileErrorMessage: undefined })
  }

  getSubmissionData() {
    return this.formRef.getFormData();
  }

  componentDidMount() {
    if (this.props.submission) {
      this.props.listAttachment(this.props.submission);
    }
  }

  render() {
    const { description } = this.props.submission;
    const { disabled, fieldErrors, attachments, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    const { fileErrorMessage } = this.state;
    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail') || fileErrorMessage}
      >
        <FieldGroup
          id="project-submission-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
        <ControlLabel>{t('attachments')}</ControlLabel>
        <DropFileList
          files={attachments.map(attachment => ProjectSubmissionDetail.createDropFileWithAttachment(attachment))}
          t={t}
          fileError={this.fileError}
          clearFileError={this.clearFileError}
          acceptFileExt=".png,.jpg,.pdf,.docx,.doc"
          onAddFile={file => this.props.createAttachment(this.props.submission, file)}
          onDeleteFile={id => this.props.deleteAttachment(id)}
        />
      </Form>
    );
  }
}

ProjectSubmissionDetail.defaultProps = {
  submission: {},
};

const mapStateToProps = state => ({
  attachments: state.submissionAttachment.orderedIds.map(id => state.submissionAttachment.objects[id]),
});

const mapDispatchToProps = dispatch => ({
  listAttachment: submission => dispatch(listAttachment(submission.id)),
  createAttachment: (submission, file) => dispatch(createAttachment(submission.id, file)).then(({ value }) => value.id),
  deleteAttachment: id => dispatch(deleteAttachment(id)),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectSubmissionDetail),
);



// WEBPACK FOOTER //
// ./src/components/project_submission/ProjectSubmissionDetail.js